module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "economy-operations-future-revenue"
  }, [_c('exceededPayments-table', {
    on: {
      "finishedLoading": function($event) {
        return _vm.$emit('finishedLoading', $event)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d04ea8d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/economy/operations/exceededPayments.vue
// module id = 833
// module chunks = 0